import { SignUp } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";
import { clerkTheme } from "@/lib/clerk-theme";

export function Register() {
  const [searchParams] = useSearchParams();
  const role = searchParams.get("role") || "teacher";

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-primary/20 to-background flex items-center justify-center p-4">
      <SignUp
        appearance={clerkTheme}
        unsafeMetadata={{ role }}
        afterSignUpUrl="/profile/photos"
        signInUrl="/login"
        routing="path"
        path="/register"
      />
    </div>
  );
}
